import { render } from "./App.vue?vue&type=template&id=fcb884fe"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fcb884fe&lang=scss"

import exportComponent from "C:\\Users\\Sekou A Sidibe\\Documents\\NTA TECH\\projets\\backoffice_operation_mouton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__